export const environment = {
  production: true,
  base_url: "/",
  base_image: "https://www.api.streaming-live.es",
  url_impresion: "https://www.api.streaming-live.es/print",
  uri: "/graphql",
  wsUrl: "wss://api.streaming-live.es/graphql",
  estadoInventario: ['VALIDO','AVERIADO','REGULAR','VENDIDO','ROBADO'],
};
